var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30C23.2845 30 30 23.2845 30 15C30 6.7155 23.2845 0 15 0C6.7155 0 0 6.7155 0 15C0 23.2845 6.7155 30 15 30ZM23.0565 10.2525C23.1267 10.1802 23.1816 10.0945 23.2179 10.0006C23.2542 9.90658 23.2712 9.80626 23.2679 9.70556C23.2647 9.60487 23.2411 9.50587 23.1987 9.41448C23.1563 9.32308 23.0959 9.24117 23.0212 9.17363C22.9464 9.10608 22.8588 9.05429 22.7636 9.02135C22.6684 8.9884 22.5675 8.97497 22.467 8.98187C22.3665 8.98876 22.2684 9.01584 22.1786 9.06147C22.0888 9.10711 22.0091 9.17038 21.9442 9.2475L12.96 19.1752L8.0175 14.457C7.87369 14.3196 7.68116 14.2449 7.48228 14.2494C7.2834 14.2539 7.09445 14.3372 6.957 14.481C6.81955 14.6248 6.74486 14.8173 6.74936 15.0162C6.75386 15.2151 6.83719 15.4041 6.981 15.5415L12.4815 20.7915L13.0387 21.324L13.5555 20.7525L23.0565 10.2525Z",
    fill: "#004AAD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.e3c999d69d463f41d47694a0dbcbd581.svg";
export { ForwardRef as ReactComponent };